import { render, staticRenderFns } from "./SimpleCheckBox.vue?vue&type=template&id=1971bd06&"
import script from "./SimpleCheckBox.vue?vue&type=script&lang=ts&"
export * from "./SimpleCheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports